import { useEffect } from 'react';
import { useMatchMedia } from '@frontend/responsiveness';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { WIDTH_DIMS } from '@frontend/design-system';
import { useTeamChatSelector } from '../../providers/team-chat.provider';
import { rotateCollapseButton } from '../tray-top-bar/tray-top-bar.styles';

export const HeaderExpandCollapseIcon = () => {
  const isSmallSpace = useMatchMedia({ maxWidth: WIDTH_DIMS.xlarge + 40 });

  const mainPanelView = useTeamChatSelector((ctx) => ctx.mainPanelView);
  const isNavExpanded = useTeamChatSelector((ctx) => ctx.isNavExpanded);
  const collapseNav = useTeamChatSelector((ctx) => ctx.collapseNav);
  const expandNav = useTeamChatSelector((ctx) => ctx.expandNav);
  const isSmallModeEnabled = useTeamChatSelector((ctx) => ctx.isSmallModeEnabled);

  const onClickExpand = () => {
    isNavExpanded ? collapseNav() : expandNav();
  };
  useEffect(() => {
    if (isSmallSpace) {
      collapseNav();
    }
  }, [isSmallSpace]);

  const mainPanelIsOpen = mainPanelView !== 'none';
  const isDisabled = !mainPanelIsOpen || isSmallSpace;
  if (isSmallModeEnabled) {
    return null;
  }
  return (
    <div css={headerIconStyles}>
      <div css={!isNavExpanded && rotateCollapseButton}>
        <SurfaceHeader.Icon
          onClick={onClickExpand}
          iconName='collapse-right'
          label=''
          disabled={isDisabled}
          trackingId='team-chat-2.0-expand-collapse-chat-list-button'
        />
      </div>
    </div>
  );
};

const headerIconStyles = {
  margin: theme.spacing(-2, 0, -2, -2),
  height: '68px',
  borderTopRightRadius: theme.spacing(1),
  // Added a custom box shadow since it’s not available in the design system (approved by design)
  boxShadow: `2px 0px 3px 0px #0021524D`,
  display: 'flex',
  alignItems: 'center',
  ':hover': {
    backgroundColor: theme.colors.neutral10,
  },
};
